/**
 * Build a FormData object
 * @returns A builder object with an add method and a toFormData method
 * @example
 * ```ts
 * const formData = FormDataBuilder().add("name", "John").toFormData();
 * ```
 */
export function FormDataBuilder() {
    const formData = new FormData();
    const builder = {
        add: (key, value) => {
            if (value instanceof File) {
                formData.append(key, value);
            }
            else if (typeof value === "object" || Array.isArray(value)) {
                formData.append(key, JSON.stringify(value));
            }
            else if (value !== undefined) {
                formData.append(key, value.toString());
            }
            return builder;
        },
        toFormData: () => formData,
    };
    return builder;
}
